import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, map, startWith, takeUntil } from 'rxjs/operators';

import { PasswordRegex } from '../../../../shared/enums/regex';
import { AuthService } from '../../../../shared/services/auth-service';

@Component({
  selector: 'app-passwords-validator',
  templateUrl: './passwords-validator.component.html',
  styleUrls: ['./passwords-validator.component.scss'],
})
export class PasswordsValidatorComponent implements OnInit, OnDestroy {

  @Output() newsPasswords = new EventEmitter<boolean>()
  @Output() newPassword = new EventEmitter<string>()

  public passwordsForm: UntypedFormGroup;
  public passwordVisible = false;
  public passwordConfirmVisible = false;
  public isPasswordEqual = { color: 'status-icon-enable', name: 'ellipse-sharp' };

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private fb: UntypedFormBuilder
    , private authS: AuthService
  ) { }

  ngOnInit() {
    this.passwordsForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12), Validators.pattern(PasswordRegex)]],
        passwordConfirm: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12), Validators.pattern(PasswordRegex)]],
      },
      {
        validator: this.authS.MatchPassword('password', 'passwordConfirm'),
      }
    );

    this.passwordsForm.statusChanges
      .pipe(startWith('INVALID'), distinctUntilChanged(), takeUntil(this.finishSubscriptions))
      .subscribe(this.passSubmit);

    this.passwordsForm.get('passwordConfirm').statusChanges
      .pipe(
        distinctUntilChanged(),
        map(v => v === 'VALID'),
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.validatePassFormat);
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  private passSubmit = () => {
    this.newsPasswords.emit(this.passwordsForm.invalid);
    if (this.passwordsForm.invalid) { return; }
    this.newPassword.emit(this.passwordsForm.get('password').value);
  }

  private validatePassFormat = (valid: boolean) => {
    if (String(this.passwordsForm.get('passwordConfirm').value).length < 1) {
      this.isPasswordEqual = { color: 'status-icon-enable', name: 'ellipse-sharp' };
    } else if (valid) {
      this.isPasswordEqual = { color: 'success', name: 'checkmark-success' };
    } else {
      this.isPasswordEqual = { color: 'danger', name: 'close-circle' };
    }
  }

}
